import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCoursesInfo, getCourses } from '../../../actions/courseActions';
import Spinner from '../../common/Spinner/Spinner';
import Courses from './Courses';


export class CoursesContainer extends Component {
  static propTypes = {
    info: PropTypes.object.isRequired,
    courses: PropTypes.array.isRequired,
    getCoursesInfo: PropTypes.func.isRequired,
    getCourses: PropTypes.func.isRequired
  }

  state = {
    modal: false
  };

  componentDidMount() {
    this.props.getCoursesInfo();
    this.props.getCourses();
  }

  toggleModalState = () => {
    this.setState({ modal: !this.state.modal }, () => {
      if (this.state.modal) document.body.classList.add('disable-scroll');
      else document.body.classList.remove('disable-scroll');
    });
  }

  render() {
    const { info, courses } = this.props;

    if (Object.keys(info).length > 0 && courses.length > 0) {
      return (
        <Courses
          info={info}
          courses={courses}
          modal={this.state.modal}
          toggleModalState={this.toggleModalState}
        />
      );
    } else {
      return (
        <div className="courses-wrapper">
          <section className="courses">
            <Spinner style={{ marginTop: '337px', marginBottom: '337px' }} />
          </section>
        </div>
      );
    }
  }
}


const mapStateToProps = (state) => ({
  info: state.courses.info,
  courses: state.courses.courses
});

const mapDispatchToProps = {
  getCoursesInfo,
  getCourses
};

export default connect(mapStateToProps, mapDispatchToProps)(CoursesContainer);



// WEBPACK FOOTER //
// ./src/components/Home/Courses/CoursesContainer.js